import { BlisseyParamsWithIATA } from '../blissey/blissey.types';

import { getLocationIdByIATA } from './get_location_id_by_iata';
import { getHotelsByLocation } from './get_hotels_by_location';

export const getHotelsByIATA = async (params: BlisseyParamsWithIATA) => {
  const locationId = await getLocationIdByIATA(params.iata);
  return getHotelsByLocation({ ...params, locationId });
};
